import { Logo } from "../ui/Logo";

/** Dezenter Footer mit Markenauftritt - auf jeder authentifizierten Seite über Layout.tsx eingebunden. */
export function Footer() {
  return (
    <footer className="shrink-0 border-t border-surface-border bg-black/20 px-4 md:px-6 py-3">
      <div className="flex items-center justify-between gap-3 max-w-full">
        <div className="flex items-center gap-2 opacity-70">
          <Logo className="h-6 w-auto" />
          <span className="font-display text-xs text-gray-500 uppercase tracking-wide hidden sm:inline">
            Phantom of Hell &middot; LBV-System
          </span>
        </div>
        <p className="text-[11px] text-gray-600 tracking-wide">by xVayturah</p>
      </div>
    </footer>
  );
}
